import { module } from 'angular';

import { GROUP_STAGE } from './groupStage';

export const GROUP_STAGE_MODULE = 'spinnaker.core.pipeline.stage.group';
module(GROUP_STAGE_MODULE, [GROUP_STAGE]);
